import { Component } from 'react'
import { connect } from 'react-redux'

import { logoutUser } from '../../actions/util/authenticationJwtActions'
import { removeEmpresaSelecionada } from '../../util/empresaSelecionada';
import alterarEmpresaSelecionada from '../../actions/empresa/alterarEmpresaSelecionada'

export class Logout extends Component {
  UNSAFE_componentWillMount () {
    this.props.logoutUser();
    removeEmpresaSelecionada();
    window.location.href = '/'
  }

  render () {
    return ''
  }
}

export default connect(null, { logoutUser, alterarEmpresaSelecionada })(Logout)
